<template>
  <div class="dropdown" :class="{ open: open, 'drop-up': dropUp }">
    <slot name="toggle"> </slot>
    <slot name="menu"> </slot>
  </div>
</template>

<script>
export default {
  props: {
    dropUp: {
      type: Boolean,
      default: false,
    },
    closeOnClickEl: {
      //alternate element to trigger click to close the dropdown
      //usually this is the body el, but if dropdown is used in a modal or panel
      //you can provide the panel background el as it won't work with the body el
      required: false,
    },
  },
  data() {
    return {
      open: false,
      visible: false,
      toggleEl: null,
      menuEl: null,
    }
  },
  methods: {
    toggle(e) {
      if (e) {
        e.preventDefault()
      }

      if (this.open) {
        this.hide()
      } else {
        this.show()
      }
    },
    show() {
      this.open = true

      setTimeout(() => {
        this.visible = true
      }, 100)

      document.addEventListener('keydown', this.onEscapeKeypress)

      if (this.closeOnClickEl) {
        this.closeOnClickEl.addEventListener('click', this.bodyOnClickHandler)
      } else {
        document.addEventListener('click', this.bodyOnClickHandler)
      }

      this.$emit('show')
    },
    hide(options) {
      this.visible = false

      setTimeout(() => {
        this.open = false
      }, 150)

      document.removeEventListener('keydown', this.onEscapeKeypress)

      document.removeEventListener('click', this.bodyOnClickHandler)

      this.$emit('hide', options)
    },
    onEscapeKeypress: function (e) {
      if (e.keyCode === 27) {
        this.hide({
          closedBy: 'esc',
        })
      }
    },
    bodyOnClickHandler(event) {
      // if ((this.toggleEl.contains(event.target) || this.toggleEl === event.target) ||
      //   (this.menuEl.contains(event.target) || this.menuEl === event.target)) {
      //   return;
      // }

      if (this.toggleEl.contains(event.target) || this.toggleEl === event.target) {
        return
      }

      this.hide({
        closedBy: 'bg',
      })
    },
  },
  mounted() {
    if (!this.$slots.toggle || !this.$slots.toggle[0]) throw new Error('must have a slot named="toggle"')

    this.toggleEl = this.$slots.toggle[0].elm
    this.menuEl = this.$slots.menu[0].elm

    this.toggleEl.addEventListener('click', this.toggle)
  },
  destroyed() {
    document.removeEventListener('click', this.bodyOnClickHandler)
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Dropdown.vue